import { gql } from '@apollo/client';

export default gql`
  mutation CreateProjectReport($input: ProjectReportInput!) {
    createProjectReport(input: { projectReport: $input }) {
      projectReport {
        id
      }
    }
  }
`;
